const dateStringFormats = {
  ru: 'DD.MM.YYYY',
  en: 'MM/DD/YYYY'
}

export default dateStringFormats;
